import { Box, Typography, Button, Container, Grid } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";
import {Link} from "react-router-dom"

const AutomationInfo = () => {
  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Header */}
        <Typography
          variant="h3"
          sx={{
            textAlign: "center",
            color: "primary.main",
            fontWeight: "bold",
            mb: 6,
          }}
        >
          Power of Automation in Accounting
        </Typography>

        {/* Automation Benefits */}
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: "background.paper",
                boxShadow: 3,
                height: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
              >
                Automated Bookkeeping
              </Typography>
              <Typography variant="body2" color="text.secondary">
                No more manual entries. Our AI automates bookkeeping tasks,
                ensuring every transaction is categorized and recorded
                accurately.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: "background.paper",
                boxShadow: 3,
                height: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
              >
                Real-Time Financial Reports
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Get instant balance sheets, profit & loss statements, and cash
                flow analysis — always up to date without waiting for month-end
                reports.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: "background.paper",
                boxShadow: 3,
                height: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
              >
                Compliance Alerts
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Never miss a deadline. Automated alerts keep you on top of GST
                filings, tax returns, and compliance updates effortlessly.
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                p: 3,
                borderRadius: 3,
                bgcolor: "background.paper",
                boxShadow: 3,
                height: "100%",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "primary.main", mb: 1 }}
              >
                Smart Expense Tracking
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Automatically categorize expenses, detect unusual spending, and
                provide insights to optimize costs.
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* CTA Section */}
        <Box
          sx={{
            textAlign: "center",
            mt: 8,
            p: 4,
            borderRadius: 3,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }}>
            Let AI Automation Handle Your Accounting
          </Typography>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            color="primary"
            size="large"
            sx={{ px: 4, py: 1.5, borderRadius: 2, textTransform: "none" }}
          >
            Get Started Today
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default AutomationInfo;
